import {createReducer} from "redux-act";
import {
	closeNotificationBar,
	closePlayZoneBanner,
	closePromoBanner,
	openPromoBanner,
} from "modules/actions";
import {ProjectName, PROJECT_NAME} from "modules";

const DEFAULT_PROMO_CLOSED = [
	ProjectName.FantasyDaily,
	ProjectName.MatchPredictor,
	ProjectName.Budweiserpotm,
	ProjectName.WhoAmI,
	ProjectName.Trivia,
	ProjectName.Brackets,
	ProjectName.Gott,
].includes(PROJECT_NAME as ProjectName);

const initial = {
	isNotificationOpen: true,
	isPromoBannerOpen: !DEFAULT_PROMO_CLOSED,
	isPlayZoneBannerOpen: true,
};

export const notification_bar = createReducer({}, initial)
	.on(closeNotificationBar, (state) => ({
		...state,
		isNotificationOpen: false,
	}))
	.on(openPromoBanner, (state) => ({
		...state,
		isPromoBannerOpen: true,
	}))
	.on(closePromoBanner, (state) => ({
		...state,
		isPromoBannerOpen: false,
	}))
	.on(closePlayZoneBanner, (state) => ({
		...state,
		isPlayZoneBannerOpen: false,
	}));
